import { type IconLibrary } from 'src/components/DynamicIcon/dynamic-icon';
import { NotificationRaw } from 'src/types';

export enum NotificationChannelType {
  Email = 'email',
  InApp = 'in_app',
  Push = 'push',
}

export enum NotificationStatus {
  Unread = 'unread',
  Read = 'read',
  Archived = 'archived',
}

export enum NotificationPreferenceRole {
  Assignee = 'assignee',
  Follower = 'follower',
}

export enum NotificationEvent {
  NewConversation = 'new_conversation',
  ConversationAssignment = 'conversation_assignment',
  PrivateMessageInConversation = 'private_message_in_conversation',
  PublicMessageInConversation = 'public_message_in_conversation',
  ConversationChangedToOpen = 'conversation_changed_to_open',
  ConversationChangedToSolved = 'conversation_changed_to_solved',
  ConversationChangedToOnHold = 'conversation_changed_to_on_hold',
  ConversationChangedToSnoozed = 'conversation_changed_to_snoozed',
  ConversationChangedToClosed = 'conversation_changed_to_closed',
  ConversationUnsnoozed = 'conversation_unsnoozed',
  Mention = 'mention',
  ConversationMessageReaction = 'conversation_message_reaction',
  ServiceLevelChanged = 'service_level_change',
  ClientCreated = 'client_created',
  SiteCreated = 'site_created',
  WeeklySiteDigest = 'weekly_site_digest',
  SignalScheduleStart = 'signal_schedule_start',
  AssigneeGroupAssignment = 'assignee_group_assignment',
}

export type Notification = Omit<
  NotificationRaw,
  | 'partner'
  | 'platformUser'
  | 'status'
  | 'notificationEventId'
  | 'flowInitiatorEntity'
  | 'platformUserFlowInitiator'
  | 'clientFlowInitiator'
> & {
  status: NotificationStatus;
  notificationChannelId: NotificationChannelType;
  notificationEventId: NotificationEvent;
  author: {
    id: string;
    fullName: string;
    firstName: string;
    lastName: string;
  };
  entityStatus: {
    icon: string;
    library?: IconLibrary;
    colorPath: string;
    tooltip?: string;
  };
  parsedPayload?: {
    conversation: {
      status: { id: string; name: string };
      workspaceId: number;
      partnerId: number;
      subject: string;
    };
  } | null;
};
